// DEPENDENCIES
import React from "react";
import { connect } from "react-redux";
// COMPONENTS
import { NavLink } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
// SERVICES AND HELPERS
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { dashIfNull } from "../../../helpers/helper";
import Constants from "../../../constants/constants";
import * as clientProfileOverView from "../../../redux/ClientProfileOverViewRedux";

const ProfileCard = (props) => {
    const { clientId, clientProfile } = props;

    return (
        <>
            <div
                className="flex-row-auto offcanvas-mobile w-250px w-xxl-350px"
                id="kt_profile_aside"
            >
                <div className="card card-custom card-stretch">
                    <div className="card-body pt-4">
                        <div className="d-flex align-items-center">
                            <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                <div
                                    className="symbol-label background-image-container"
                                    style={{ backgroundImage: `url(${Constants.API_URL + clientProfile.imageUrl})` }}
                                ></div>
                                <i className="symbol-badge bg-success"></i>
                            </div>
                            <div>
                                <a
                                    href="#"
                                    className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
                                >
                                    {clientProfile.name}
                                </a>
                            </div>
                        </div>
                        <div className="py-9">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-weight-bold mr-2">Email:</span>
                                <span className="text-muted text-hover-primary">
                                    {dashIfNull(clientProfile.email)}
                                </span>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-2">
                                <span className="font-weight-bold mr-2">Phone: </span>
                                <span className="text-muted">{dashIfNull(clientProfile.primaryPhone)}</span>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <span className="font-weight-bold mr-2">Location:</span>
                                <span className="text-muted"> {dashIfNull(clientProfile.location)}</span>
                            </div>
                        </div>
                        <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                            <div className="navi-item mb-2">
                                <NavLink
                                    to={"/management/client-detail/general-information/" + clientId}
                                    className="navi-link py-4"
                                    activeClassName="active"
                                >
                                    <span className="navi-icon mr-2">
                                        <span className="svg-icon">
                                            <SVG
                                                src={toAbsoluteUrl(
                                                    "/media/svg/icons/Design/Layers.svg"
                                                )}
                                            ></SVG>{" "}
                                        </span>
                                    </span>
                                    <span className="navi-text font-size-lg">
                                        General Information
                                    </span>
                                </NavLink>
                            </div>
                            <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                                <div className="navi-item mb-2">
                                    <NavLink
                                        to={"/management/client-detail/locations/" + clientId}
                                        className="navi-link py-4"
                                        activeClassName="active"
                                    >
                                        <span className="navi-icon mr-2">
                                            <span className="svg-icon">
                                                <SVG
                                                    src={toAbsoluteUrl(
                                                        "/media/svg/icons/Map/marker1.svg"
                                                    )}
                                                ></SVG>{" "}
                                            </span>
                                        </span>
                                        <span className="navi-text font-size-lg">
                                            Locations
                                        </span>
                                    </NavLink>
                                </div>
                            </div>
                            <div className="navi-item mb-2">
                                <NavLink
                                    to={"/management/client-detail/jobs/" + clientId}
                                    className="navi-link py-4"
                                    activeClassName="active"
                                >
                                    <span className="navi-icon mr-2">
                                        <span className="svg-icon">
                                            <SVG
                                                src={toAbsoluteUrl(
                                                    "/media/svg/icons/Code/Git4.svg"
                                                )}
                                            ></SVG>{" "}
                                        </span>
                                    </span>
                                    <span className="navi-text font-size-lg">
                                        Projects
                                    </span>
                                </NavLink>
                            </div>
                            <div className="navi-item mb-2">
                                <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip>Coming soon...</Tooltip>}
                                >
                                    <a href="#" className="navi-link py-4">
                                        <span className="navi-icon mr-2">
                                            <span className="svg-icon">
                                                <SVG
                                                    src={toAbsoluteUrl(
                                                        "/media/svg/icons/Files/Selected-file.svg"
                                                    )}
                                                ></SVG>{" "}
                                            </span>
                                        </span>
                                        <span className="navi-text font-size-lg">
                                            Invoices
                                        </span>
                                    </a>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    userProfileState: state.userProfile,
    auth: state.auth,
    clientProfile: state.clientProfile
});

export default connect(mapStateToProps, clientProfileOverView.actions)(ProfileCard);